import {
  CustomAuthPublicClientApplication,
  ICustomAuthPublicClientApplication,
} from "@azure/msal-browser/custom-auth";
import { customAuthConfig } from "../config/auth-config";

let clientInstance: ICustomAuthPublicClientApplication | null = null;

export async function getMsalClient(): Promise<ICustomAuthPublicClientApplication> {
  if (!clientInstance) {
    console.log('[MSAL] Initializing CustomAuthPublicClientApplication...');
    clientInstance =
      await CustomAuthPublicClientApplication.create(customAuthConfig);
    console.log('[MSAL] Client initialized successfully');
  }
  return clientInstance;
}

export const msalAuthService = {
  getClient: getMsalClient,
};
